import useScrollTrigger from '@ahamove/web-components/lib/useScrollTrigger';
import * as React from 'react';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  children: React.ReactElement;
}

export default function ElevationScrollHeaderMobile(props: Props) {
  const { children, window } = props;
  const sxDefault = {
    position: 'fixed',
    top: 0,
    right: 0,
    left: 0,
    zIndex: 50,
  };

  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 36,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    sx: () => ({
      ...sxDefault,
      bgcolor: trigger ? 'common.white' : 'transparent',
      borderColor: trigger ? 'divider' : 'transparent',
      // boxShadow: trigger ? theme.shadows[1] : 'none',
    }),
  });
}
